import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import { queryClient } from './lib/queryClient'
import { router } from './router'
import { AuthProvider } from './providers/AuthProvider'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider wires the API client to the stores and resolves the
          session before anything renders, so no screen ever paints with
          capabilities it then loses. */}
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>

      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{ style: { fontFamily: 'DM Sans Variable, sans-serif' } }}
      />
    </QueryClientProvider>
  </StrictMode>,
)
